import React from 'react';
import { Flex, Table } from '@zillow/constellation';
import { IAdminUserData } from '../../../../types/administration/userAdministration/IAdminUser';
import { BodyTextTW } from '../../../../tailwindComponents/bodyText/BodyTextTW';
import { IdentityMenuDropdown } from './IdentityMenuDropdown';

export const TableBody: React.FC<{
  adminUsers: IAdminUserData[];
  setUpdateAdminUser: (adminUser: IAdminUserData) => void;
  setUpdateUserProfile: (adminUser: IAdminUserData) => void;
}> = ({ adminUsers, setUpdateAdminUser, setUpdateUserProfile }) => {
  return (
    <Table.Body>
      {adminUsers.map((user) => (
        <Table.Row key={user.id}>
          <Table.Cell>
            <Flex display="flex" alignItems="center">
              <BodyTextTW>{user.fullName}</BodyTextTW>
            </Flex>
          </Table.Cell>
          <Table.Cell>
            <Flex display="flex" alignItems="center">
              <BodyTextTW>{user.email}</BodyTextTW>
            </Flex>
          </Table.Cell>
          <Table.Cell>
            <Flex display="flex" alignItems="center">
              {!user.identity.roles.length ? (
                <BodyTextTW>No Roles</BodyTextTW>
              ) : (
                <BodyTextTW>{user.identity.roles.map(({ label }: { label: string }) => label).join(', ')}</BodyTextTW>
              )}
            </Flex>
          </Table.Cell>
          <Table.Cell>
            <Flex display="flex" alignItems="center">
              <BodyTextTW>{user.identity.enabled ? 'Active' : 'Deactivated'}</BodyTextTW>
            </Flex>
          </Table.Cell>
          <Table.Cell>
            <Flex display="flex" alignItems="center" justifyContent="center">
              <IdentityMenuDropdown 
                adminUser={user} 
                setUpdateAdminUser={setUpdateAdminUser}
                setUpdateUserProfile={setUpdateUserProfile}
              />
            </Flex>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  );
};
